import React, { useState, useEffect } from 'react';
import style from "./css/supportPage.module.css";
import { apiURL_BACKEND, UserDataInterface, PackagePassInterface } from './Vars';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
interface SupportPageProps {

}
const allSupportType = [
    "Withdrawal issues",
    "Deposit Issue",
    "Issues With Picks",
    "Issues With Subscription"
]
const SupportPage: React.FC<SupportPageProps> = () => {
    const [toggleOn, changeToggle] = useState<boolean>(false);


    const [supportType, setSupportType] = useState<string>("Withdrawal issues");
    const [trackID,setSupportTrackID] = useState<string>("");


    const changeNavStyle = () => {
        document.documentElement.style.setProperty('--nav-text-color', 'black');
        document.documentElement.style.setProperty('--pseudo-nav-display', 'flex');
    };
    useEffect(() => {
        changeNavStyle();
        axios.get(`${apiURL_BACKEND}/getSupportTrackID/`).then(
            (res)=>{
                const data = res.data
                console.log(data);
                formData.trackID = res.data.trackID;
                setSupportTrackID(data.trackID);
            }
        )
    }, [])
    const toggleDropdown = () => {
        changeToggle(!toggleOn);
    };

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        supportType: "Select an issue",
        subject: "",
        description: "",
        trackID:trackID
    });
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    useEffect(()=>{console.log(formData)},[formData])
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiURL_BACKEND}/submitSupportRequest/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });
            if (response.ok) {
                alert("Form submitted successfully!");
                window.location.reload();
            } else {
                alert("Submission failed!");
            }
        } catch (error) {
            console.error("Error submitting form", error);
        }
    };
    return (
        <>
            <div className={style.support}>
                <h1>Support Box</h1>
                <form className={style.supportForm} onSubmit={handleSubmit}>
                    <h2>Ticket ID #{trackID}</h2>

                    <div style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gap: '20px',
                        flexWrap:"wrap"

                    }}>
                        <div className={style.inputArea}>
                            <label htmlFor="">Name</label>
                            <input type="text"  name="name" className={style.inputArea_input} placeholder='Enter your name' value={formData.name} onChange={handleChange}  />
                        </div>

                        <div className={style.inputArea}>
                            <label htmlFor="">Email </label>
                            <input type="text"  name="email" className={style.inputArea_input} value={formData.email} onChange={handleChange} placeholder='Enter your email' />
                        </div>
                    </div>

                    <div style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gap: '20px',
                        flexWrap:"wrap"
                    }}>
                        <div className={style.inputArea}>
                            <label htmlFor="">Issue type</label>

                            <div className={style.inputArea_dropdown} onClick={toggleDropdown}>
                                <div className={style.dropDownField}>
                                    <div className="drop-down-text" id="drop-down-text">
                                        <div className="currency-name">{supportType}</div>
                                    </div>
                                    <div className="drop-down-icon" id="drop-down-icon" style={{ width: '26px', height: '24px' }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28" viewBox="0 0 26 28" fill="none">
                                            <path d="M13 17.9667L6.5 10.9667L8.01667 9.33333L13 14.7L17.9833 9.33333L19.5 10.9667L13 17.9667Z" fill="#5F6368" />
                                        </svg>
                                    </div>
                                </div>
                                {
                                    toggleOn ? (


                                        <div className={style.dropdownList} id="dropdownList">

                                            {
                                                allSupportType.map((__support, index) => (
                                                    <div className={style.dropDownItem}>
                                                        <div className={style.dropDownText} id="drop-down-text" onClick={(e) => {
                                                            e.preventDefault();
                                                            setSupportType(__support);
                                                           setFormData({ ...formData, supportType: __support });
                                                        }}>
                                                            <p>{__support}</p>
                                                        </div>
                                                        {
                                                            index < Number(allSupportType.length) - 1 ? (
                                                                <div className={style.dropDownHr}></div>

                                                            ) : (<></>)
                                                        }
                                                    </div>
                                                ))
                                            }



                                        </div>
                                    ) : (
                                        <></>
                                    )
                                }




                            </div>

                        </div>


                        <div className={style.inputArea} >
                            <label htmlFor="" >Subject</label>
                            <input type="text"  name="subject" className={style.inputArea_input} placeholder='Enter subject' value={formData.subject} onChange={handleChange}/>
                        </div>



                    </div>


                    <div className={style.inputArea} style={{ gap: '20px', marginTop: '25px' }}>
                        <label htmlFor="">Description</label>
                        <textarea className={style.supportDes} name="description" id="" placeholder='Please describe the issue' value={formData.description} onChange={handleChange}></textarea>
                    </div>


                    <button className={style.formSubmit}>
                        <p>Submit</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 40 34" fill="none">
                            <path d="M0 33.3333V20.8333L16.6667 16.6667L0 12.5V0L39.5833 16.6667L0 33.3333Z" fill="white" />
                        </svg>
                    </button>

                </form>
            </div>
        </>
    );
};

export default SupportPage;